module.exports = "/_next/static/images/WhatIsCyberInsuranceBgWavesRight1-ac8e885604c7871cf18eadef51d22457.svg";